import http from '@frontend/api/http';
import { HYPATIA_URL } from '@frontend/envConfig';
import { ScheduledTrigger } from '@frontend/types/workflow-agent';

// Type for partial updates to scheduled triggers
export type ScheduledTriggerUpdate = Partial<Omit<ScheduledTrigger, 'id' | 'type'>>;

export const updateScheduledTrigger = async (
  url: string,
  updates: ScheduledTriggerUpdate
): Promise<ScheduledTrigger> => {
  const response = await http.patch<ScheduledTrigger>(url, updates);
  return response.data;
};

export const createScheduledTrigger = async (
  agentId: string,
  instanceId: string,
  trigger: Record<string, unknown>
): Promise<ScheduledTrigger> => {
  const url = `${HYPATIA_URL}/api/v1/${instanceId}/agents/workflows/${agentId}/triggers/scheduled`;
  const response = await http.post<ScheduledTrigger>(url, trigger);
  return response.data;
};

export const getScheduledTrigger = async (url: string): Promise<ScheduledTrigger> => {
  const response = await http.get<ScheduledTrigger>(url);
  return response.data;
};

export const deleteScheduledTrigger = async (url: string): Promise<void> => {
  await http.delete(url);
};
